import { MenuItem, TextField } from '@mui/material';
import React from 'react';
import { ReferenceDto } from '../../services/dtos/reference.dto';
import { FieldHookConfig, useField } from 'formik';

type MyInputProps = FieldHookConfig<string> & {
    required?: boolean;
    id: string;
    label: string;
    name: string;
    values: ReferenceDto[];
    handleChange?: any;
};

/**
 * Composant select
 * @param props MyInputProps
 * @constructor
 */
function SelectForm(props: MyInputProps) {
    const [field] = useField(props);

    /**
     * Gestionnaire d'évènements à la sélection d'une valeur dans la liste
     * @param event évènement déclencheur
     */
    const handleCheckSelectValue = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let isValid = true;
        if ((isValid || !event?.target?.value) && props.handleChange) {
            props.handleChange(event);
        }
        (isValid || !event?.target?.value) && field.onChange(event);
    };

    return (
        <TextField
            {...field}
            required={props.required}
            id={props.id}
            label={props.label}
            name={props.name}
            onChange={event => handleCheckSelectValue(event)}
            fullWidth
            select
            data-testid={`list-${props.id}`}
        >
            {props.values.length ? (
                props.values.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                        {label}
                    </MenuItem>
                ))
            ) : (
                <MenuItem>Chargement...</MenuItem>
            )}
        </TextField>
    );
}
export default SelectForm;
